export const subject={"1":"科目一","2":"科目二","3":"科目三","4":"科目四","5":"满分学习","6":"注销恢复"};
export const carType={"1":"小车","2":"货车","3":"客车","4":"摩托车"};
export const topicFrom={"0": "专项练习", "1": "顺序练习", "2": "随机练习", "3": "新增题", "4": "精选题库", "5": "全真模拟", "6": "收藏题", "7": "直播教学","8":"满分学习","9":"注销恢复","10":"地方题库","11":"模拟成绩"};

export function formatPrice(price){
  price=price/100;
  return (price).toFixed(2);
}



// WEBPACK FOOTER //
// ./src/utils/public.js